export enum EBaseSetupGuideCampaign {
  SETUP_TRAFFIC_SPLIT = 'SETUP_TRAFFIC_SPLIT',
  SETUP_MARKET_LANGUAGE = 'SETUP_MARKET_LANGUAGE',
  SET_WINNING_METRIC = 'SET_WINNING_METRIC',
  SET_UP_DEVICE_VISITOR_TRAFFIC_SOURCE_MARKET = 'SET_UP_DEVICE_VISITOR_TRAFFIC_SOURCE_MARKET',
  START_EXPERIMENT = 'START_EXPERIMENT',
}
